"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = require("../../Layout/Flex");

var _Button = require("../../Button");

var _InputContainer = _interopRequireDefault(require("../../Form/Input/InputContainer"));

var _VisuallyHidden = _interopRequireDefault(require("../../VisuallyHidden"));

var _Constant = require("../Constant");

var _Error = _interopRequireDefault(require("../../Form/Error"));

var _Input = _interopRequireDefault(require("./Input"));

var _Label = require("./Label");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  display: inline;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: 1px solid ", ";\n  margin-top: 10px;\n\n  /* disabledStyles is used instead of the disabled attribute because border styles are placed on the InputWrapper instead of directly on the input */\n  &:hover {\n    border-color: ", ";\n  }\n\n  /* The focus ring surrounds both the input and SubmitButton when the input has focus */\n  &:focus-within {\n    outline: 2px solid ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: none;\n  margin-top: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Input = (0, _styledComponents.default)(_Input.default)(_templateObject());
var InputWrapper = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject2(), _Constant.Color.GREY_4, function (props) {
  return props.disabledStyles ? '' : _Constant.Color.FOCUS_B;
}, _Constant.Color.FOCUS_B);
var Error = (0, _styledComponents.default)(_Error.default)(_templateObject3(), _Label.dashboardErrorStyles);

var SingleInputSubmit = function SingleInputSubmit(_ref) {
  var handleSubmit = _ref.handleSubmit,
      submitState = _ref.submitState,
      errorText = _ref.errorText,
      type = _ref.type,
      placeholder = _ref.placeholder,
      id = _ref.id,
      disabled = _ref.disabled,
      fsMask = _ref.fsMask,
      props = (0, _objectWithoutProperties2.default)(_ref, ["handleSubmit", "submitState", "errorText", "type", "placeholder", "id", "disabled", "fsMask"]);
  var disabledStyles = disabled ? true : false;
  return /*#__PURE__*/_react.default.createElement(_InputContainer.default, {
    errorText: errorText
  }, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, {
    tag: "label",
    htmlFor: id
  }, placeholder), /*#__PURE__*/_react.default.createElement(Error, null, errorText), /*#__PURE__*/_react.default.createElement(InputWrapper, {
    disabledStyles: disabledStyles
  }, /*#__PURE__*/_react.default.createElement(Input, (0, _extends2.default)({
    id: id,
    placeholder: placeholder,
    disabled: disabled,
    fsMask: fsMask
  }, props)), /*#__PURE__*/_react.default.createElement(_Button.SubmitButton, {
    type: "submit",
    onClick: handleSubmit,
    status: submitState,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, "Submit"))));
};

SingleInputSubmit.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** The label for the input */
  label: _propTypes.default.string.isRequired,

  /** Submit form handler */
  handleSubmit: _propTypes.default.func.isRequired,

  /** Status of the form */
  submitState: _propTypes.default.string.isRequired,

  /** Value that controls the input */
  value: _propTypes.default.string,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** The type supploed to the input */
  type: _propTypes.default.string,

  /** Placeholder text in input */
  placeholder: _propTypes.default.string.isRequired,

  /**
   * Adds `disabled` attribute to input and button when true.
   * Also used to prevent hover styles when input is disabled.
   */
  disabled: _propTypes.default.bool,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
SingleInputSubmit.defaultProps = {
  value: '',
  errorText: '',
  type: 'text',
  disabled: false,
  fsMask: true
};
var _default = SingleInputSubmit;
exports.default = _default;